import { upcomingGames } from '@/mocks/games';

export default function GamesSection() {
  return (
    <section className="w-full bg-[#f8f5ff] py-20 px-6 md:px-12">
      {/* Background accent */}
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="inline-block w-12 h-0.5 bg-[#4a1a6b]"></span>
            <h2
              className="text-4xl md:text-5xl font-black uppercase text-gray-900 tracking-tight"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              Upcoming <span className="text-[#4a1a6b]">Games</span>
            </h2>
            <span className="inline-block w-12 h-0.5 bg-[#4a1a6b]"></span>
          </div>
          <p className="text-gray-500 text-sm tracking-wider uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>
            2026 Preseason &amp; Regular Season Schedule
          </p>
        </div>

        {/* Games Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {upcomingGames.map((game, index) => (
            <div
              key={game.id}
              className={`relative rounded-2xl overflow-hidden cursor-pointer group transition-transform duration-300 hover:-translate-y-1 ${
                index % 2 === 0
                  ? 'bg-[#4a1a6b] text-white'
                  : 'bg-white border border-gray-200 text-gray-900'
              }`}
            >
              {/* Location badge */}
              <div className="p-5 pb-0">
                <span
                  className={`inline-block text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-4 ${
                    game.location === 'HOME'
                      ? 'bg-[#ffd700] text-[#4a1a6b]'
                      : index % 2 === 0
                      ? 'bg-white/20 text-white'
                      : 'bg-gray-100 text-gray-600'
                  }`}
                  style={{ fontFamily: "'Oswald', sans-serif" }}
                >
                  {game.location}
                </span>
              </div>

              {/* Day & Date */}
              <div className="px-5">
                <div
                  className={`text-5xl font-black leading-none ${index % 2 === 0 ? 'text-white' : 'text-gray-900'}`}
                  style={{ fontFamily: "'Oswald', sans-serif" }}
                >
                  {game.day}
                </div>
                <div
                  className={`text-sm font-bold tracking-widest mt-1 ${index % 2 === 0 ? 'text-white/70' : 'text-gray-500'}`}
                  style={{ fontFamily: "'Oswald', sans-serif" }}
                >
                  {game.date}
                </div>
              </div>

              {/* VS */}
              <div className="px-5 mt-4">
                <div
                  className={`text-xs font-bold tracking-widest uppercase mb-1 ${index % 2 === 0 ? 'text-white/50' : 'text-gray-400'}`}
                  style={{ fontFamily: "'Oswald', sans-serif" }}
                >
                  vs.
                </div>
                <div
                  className={`text-base font-black uppercase leading-tight ${index % 2 === 0 ? 'text-[#ffd700]' : 'text-[#4a1a6b]'}`}
                  style={{ fontFamily: "'Oswald', sans-serif" }}
                >
                  {game.opponentShort}
                </div>
              </div>

              {/* Opponent Logo */}
              <div className="px-5 pb-5 mt-4 flex items-center justify-between">
                <div>
                  <div
                    className={`text-xs ${index % 2 === 0 ? 'text-white/50' : 'text-gray-400'}`}
                    style={{ fontFamily: "'Oswald', sans-serif" }}
                  >
                    {game.time}
                  </div>
                  <div
                    className={`text-xs mt-0.5 ${index % 2 === 0 ? 'text-white/40' : 'text-gray-300'}`}
                    style={{ fontFamily: "'Oswald', sans-serif" }}
                  >
                    {game.venue.split(',')[0]}
                  </div>
                </div>
                <div className="w-12 h-12 flex items-center justify-center rounded-full overflow-hidden bg-white/10">
                  <img
                    src={game.opponentLogo}
                    alt={game.opponent}
                    className="w-10 h-10 object-cover rounded-full"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Vikings Logo Banner */}
        <div className="mt-12 rounded-2xl overflow-hidden relative h-32 md:h-40">
          <img
            src="https://public.readdy.ai/ai/img_res/fe708f5d0018fc2630e3fff6b9d7a840.jpg"
            alt="Vikings fans"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#4a1a6b]/80 via-[#4a1a6b]/40 to-transparent flex items-center px-10">
            <div>
              <p
                className="text-white/70 text-xs tracking-widest uppercase mb-1"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                Season Tickets Available
              </p>
              <h3
                className="text-white text-2xl md:text-3xl font-black uppercase"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                Be There for Every Moment
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
